import React, {useState} from "react";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CloseIcon from "../../assets/svg/icon_close.svg?react";
import {RiMenuLine} from "@remixicon/react";
import {grey} from "../../themes/colors/aptosColorPalette";
import Box from "@mui/material/Box";
import {Divider, useTheme} from "@mui/material";
import {useNavigate} from "../../routing";
import {WalletConnector} from "../../components/WalletConnector";
import {useGlobalState} from "../../global-config/GlobalConfig";
import {useWallet} from "@topo/wallet-adapter-react";
import {sortPetraFirst} from "../../utils";
import {useGetInDevnet} from "../../api/hooks/useGetInDevnet";

export default function NavMobile() {
  const inDevnet = useGetInDevnet();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const navigate = useNavigate();
  const [state] = useGlobalState();
  const {account} = useWallet();
  const menuOpen = Boolean(menuAnchorEl);

  const handleIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleCloseAndNavigate = (to: string) => {
    setMenuAnchorEl(null);
    navigate(to);
  };

  return (
    <Box sx={{display: {xs: "block", lg: "none"}}}>
      <Button
        id="nav-mobile-button"
        aria-controls={menuOpen ? "nav-mobile-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
        onClick={handleIconClick}
        sx={{
          minWidth: "0",
          width: "1.5rem",
          padding: "0",
          ml: 2,
          color: "inherit",
          "&:hover": {
            background: "transparent",
            color: `${theme.palette.mode === "dark" ? grey[100] : grey[400]}`,
          },
          "&[aria-expanded=true]": {opacity: "0.7"},
        }}
      >
        {menuOpen ? <CloseIcon /> : <RiMenuLine size={24} />}
      </Button>
      <Menu
        disableScrollLock
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "nav-mobile-button",
          sx: {
            minWidth: 200,
            padding: "0.5rem",
          },
        }}
        slotProps={{
          paper: {
            sx: {
              right: 0,
              left: "auto !important",
            },
          },
        }}
        sx={{
          marginTop: "1rem",
        }}
      >
        <MenuItem onClick={() => handleCloseAndNavigate("/")} sx={{py: 1.5}}>
          Home
        </MenuItem>
        <MenuItem
          onClick={() => handleCloseAndNavigate("/transactions")}
          sx={{py: 1.5}}
        >
          Transactions
        </MenuItem>
        <MenuItem
          onClick={() => handleCloseAndNavigate("/contribution")}
          sx={{py: 1.5}}
        >
          Contribution
        </MenuItem>
        {!inDevnet && (
          <MenuItem
            onClick={() => handleCloseAndNavigate("/analytics")}
            sx={{py: 1.5}}
          >
            Analytics
          </MenuItem>
        )}
        <MenuItem
          onClick={() => handleCloseAndNavigate("/validators")}
          sx={{py: 1.5}}
        >
          Validators
        </MenuItem>
        <MenuItem
          onClick={() => handleCloseAndNavigate("/blocks")}
          sx={{py: 1.5}}
        >
          Blocks
        </MenuItem>
        <Divider sx={{my: 1}} />
        <Box sx={{px: 2, py: 1}}>
          <WalletConnector
            networkSupport={state.network_name}
            handleNavigate={() => navigate(`/account/${account?.address}`)}
            sortAvailableWallets={sortPetraFirst}
            sortInstallableWallets={sortPetraFirst}
            modalMaxWidth="sm"
          />
        </Box>
      </Menu>
    </Box>
  );
}
